export const SalesforceStrCual = {
    FORMULARIO_COMPRA: 'Formulario de compra',
    URL_PERSONALIZADA_ASESOR: 'URL personalizada asesor',
    FORMULARIO_CONTACTO: 'Formulario de contacto'
}
